// Entry point for the build script in your package.json

// Rails
import Rails from "@rails/ujs";
Rails.start();

// Stimulus
import { Application } from "stimulus";
import HeaderController from "./controllers/HeaderController";
const application = Application.start();
application.register("header", HeaderController);

// Responsive embeds
import responsiveEmbeds from "./lib/responsiveEmbeds";
responsiveEmbeds();

// React
import * as Tombolo from "tombolo";
import * as components from "./components";
Tombolo.start(components);
